module.exports = __webpack_public_path__ + "static_pc/img/ba03.9a585a08.png";